/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { union, alias } from '@ember/object/computed';
import { service } from '@ember/service';
import GradingMethod from 'linced-app/enums/grading-method';

export default class AssessmentController extends Controller {
  @service
  session;

  @service
  store;

  @alias('model.assessment')
  assessment;

  @alias('model.person')
  person;

  @alias('model.modules')
  modules;

  @computed(
    'model.grades.@each.{numericAwarded,numericScale,selectAwarded,multiSelectAwarded}',
    'modules.[]',
  )
  get latestGrades() {
    return this.modules.reduce((modules, module) => {
      modules[module.id] = this.findLatestGrade(module);
      return modules;
    }, {});
  }

  GradingMethod = GradingMethod;

  @union('model.posts', 'model.assessmentPosts')
  allPosts;

  @action
  refreshGrades() {
    this.get('model.grades').update();
  }

  findLatestGrade(module) {
    let moduleGrades = this.get('model.grades').filter(
      (item) => item.module.id === module.id,
    );
    if (moduleGrades && moduleGrades.length) {
      return moduleGrades
        .slice()
        .sort((a, b) => a.createTime - b.createTime)
        .at(-1);
    }

    return null;
  }
}
